import React, { useEffect, useState } from 'react';
import {
  Alert,
  Button,
  Card, Col, Row,
  Table,
} from 'react-bootstrap';
import PropTypes from 'prop-types';
import Swal from 'sweetalert2';

import { getRaters, sendRaterEmail } from '../../../bridge';
import { __ } from '../../../helpers/translations';
import { ITPMETRICS_BLUE } from '../common/Colours';
import AddRaterModal from '../survey-dashboard/modals/AddRaterModal';

function DesignatedRaterDashboard({ respondent }) {
  const [raters, setRaters] = useState([]);
  const [showAddRaterModal, setShowAddRaterModal] = useState(false);

  if (respondent.templateId !== 'leadership') {
    return null;
  }

  const populate = async () => {
    const { response } = await getRaters(respondent.respondentId);
    setRaters(response || []);
  };

  const sendEmail = async (raterId) => {
    await sendRaterEmail(raterId);
  };

  useEffect(() => {
    populate();
  }, []);

  return (
    <Card className="no-print">
      <Card.Body>
        <div className="m-3 p-3">
          <Row>
            <Col><Button size="sm" onClick={() => setShowAddRaterModal(true)}>{__('G338')}</Button></Col>
            {showAddRaterModal && (
            <AddRaterModal
              respondentId={respondent.respondentId}
              onChanged={() => {
                setShowAddRaterModal(false);
                populate();
              }}
              onCancel={() => setShowAddRaterModal(false)}
            />
            )}
          </Row>
          <br />
          <Row>
            <Col>
              {raters.length === 0 && (
              <Alert variant="danger" className="my-3 py-2">
                <small>You have no designated raters.</small>
              </Alert>
              )}
              {raters.filter((r) => r.status === 'completed').length < 3 && (
              <Alert variant="warning" className="my-3 py-2">
                <small>You require at least 3 completed designated rater respones. Otherwise, you will not have any quantitative or qualitative feedback on your report.</small>
              </Alert>
              )}
            </Col>
          </Row>
          {raters.length > 0
          && (
          <Table striped size="sm">
            <thead>
              <tr style={{ fontSize: '11px' }}>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Email</th>
                <th>Status</th>
                <th>{}</th>
              </tr>
            </thead>
            <tbody style={{ fontSize: '14px' }}>
              {raters.map((rater) => (
                <tr key={`rater-${rater.respondentId}`}>
                  <td>{rater.firstName}</td>
                  <td>{rater.lastName}</td>
                  <td>{rater.email}</td>
                  <td>{rater.status}</td>
                  <td>
                    {rater.status !== 'completed'
                    && (
                    <Button
                      onClick={async () => {
                        await sendEmail(rater.respondentId);
                        Swal.fire({
                          text: __('G174'),
                          icon: 'success',
                          confirmButtonColor: ITPMETRICS_BLUE,
                          confirmButtonText: __('G167'),
                        });
                      }}
                      variant="link"
                      style={{ fontSize: '14px', padding: '0px' }}
                    >
                      {__('G339')}
                    </Button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          )}
        </div>
      </Card.Body>
    </Card>
  );
}

DesignatedRaterDashboard.propTypes = {
  respondent: PropTypes.object.isRequired,
};

export default DesignatedRaterDashboard;
